
import { getSearchResponse, searchResponse } from "@/api/search";
import { defineComponent, reactive, UnwrapRef } from "vue";
import constants from "common/src/constants";

export default defineComponent({
  setup() {
    const searchRes: UnwrapRef<searchResponse> = reactive({
      kei01p: null,
      rnw01p: null,
    });

    getSearchResponse()
      .then((r) => {
        searchRes.kei01p = r.data.kei01p;
        searchRes.rnw01p = r.data.rnw01p;
      })
      .catch(() => {
        return;
      });

    return {
      searchRes,
      constants,
    };
  },
});
